import { SHIP_TYPES } from "./constants";
import { Utils } from "./Utils";
import { API } from "./API";

export class TimeTable {
  constructor() {
    this.tableBody = document.getElementById("timeTable");
    this.selectedDate = null;
    this.bookings = [];
    this.initialize();
  }

  initializeHeader() {
    const thead = document.querySelector("thead tr");
    // Clear existing th elements except the first one
    while (thead.children.length > 1) {
      thead.removeChild(thead.lastChild);
    }

    // Add ship type columns
    SHIP_TYPES.forEach((ship) => {
      const th = document.createElement("th");
      th.className = "ship-header-cell relative";

      const status = document.createElement("div");
      status.dataset.shipName = ship.name;
      status.className = "ship-status";
      status.textContent = "0";

      const imgContainer = document.createElement("div");
      imgContainer.className = "flex items-center justify-center relative";

      const imgDiv = document.createElement("div");
      imgDiv.className = "ship-image relative ship-header";
	  imgDiv.dataset.shipName = ship.name;
	  
      imgDiv.appendChild(status);

      const img = document.createElement("img");
      img.src = ship.img;
      img.alt = ship.name;
      img.className = "ship-image relative";

      imgDiv.appendChild(img);
      imgContainer.appendChild(imgDiv);

      th.appendChild(imgContainer);
      thead.appendChild(th);
    });
  }

  initialize() {
    this.initializeHeader();
    this.tableBody.innerHTML = "";

    for (let time = 8; time < 24; time += 0.5) {
	  const row = document.createElement("tr");

	  // Time cell
	  const timeCell = document.createElement("td");
	  timeCell.className = "time-cell sticky left-0 bg-white time-cell-hour";

	  // Format time (e.g., 08:00 or 08:30)
	  const hour = Math.floor(time);
	  const minutes = time % 1 === 0 ? "00" : "30";
	  timeCell.textContent = `${hour.toString().padStart(2, "0")}:${minutes}`;
	  row.appendChild(timeCell);

	  // Create cells for each ship type
	  SHIP_TYPES.forEach((ship) => {
		const cell = document.createElement("td");
		cell.className = "ship-time-cell";
		cell.dataset.hour = hour;
		cell.dataset.minutes = minutes;
		cell.dataset.shipName = ship.name;

		// Add click handler for empty cells
		cell.addEventListener("click", (e) => {
		  // Only handle clicks on the cell itself, not on booking slots
		  if (e.target === cell) {
			const departureTime = `${hour.toString().padStart(2, "0")}:${minutes}`;
			const formattedDate = Utils.formatDate(this.selectedDate);
			const queryParams = new URLSearchParams({
			  travel_date: formattedDate,
			  boat: ship.name,
			  departure_time: departureTime,
			});
			window.location.href = `/admin/booking/create?${queryParams.toString()}`;
		  }
		});

		row.appendChild(cell);
	  });

	  this.tableBody.appendChild(row);
	}
  }

  async updateDate(date) {
    this.selectedDate = date;
    await this.fetchAndRenderBookings();
  }

  async fetchAndRenderBookings() {
    if (!this.selectedDate) return;

    // Format date as DD-MM-YYYY
    const formattedDate = this.selectedDate
      .toLocaleDateString("ru-RU", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replace(/\./g, "-");

    try {
      const bookings = await API.getBookings(formattedDate);
	  const blocks = await API.getBlocks(this.selectedDate.toLocaleDateString("ru-RU"));
      this.renderBookings(bookings, blocks);
    } catch (error) {
      console.error("Error fetching bookings:", error);
    }
  }
  
  generateRandomShade() {
		const r = 255; // фиксируем красный на 255
		const g = Math.floor(Math.random() * 200); // случайное значение для зеленого (от 0 до 100)
		const b = Math.floor(Math.random() * 51); // случайное значение для синего (от 0 до 50)

		// Форматируем цвет в формате HEX
		const redShade = `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase()}`;
		
		return redShade;
  }

  renderBookings(bookings, blocks) {
	  const myblocks = blocks.blocks || {};
	  // Clear existing bookings
	  document.querySelectorAll(".booking-slot").forEach((el) => el.remove());

	  // First, create a map of all booked slots
	  const bookedSlots = new Map();
	  bookings.forEach((booking) => {
		const [hours, minutes] = booking.departure_time.split(":").map(Number);
		const startTime = hours * 60 + minutes; // Convert time to minutes
		const duration = parseInt(booking.duration) * 60; // Duration in minutes
		const startMinutes = minutes;

		// Mark all 30-minute slots of this booking as booked
		for (let time = startTime; time < startTime + duration; time += 30) {
		  const hour = Math.floor(time / 60);
		  const mins = time % 60;
		  const key = `${booking.boat}-${hour}:${mins.toString().padStart(2, "0")}`;
		  bookedSlots.set(key, booking);
		}
	  });

	  // Now render all slots (both booked and available)
	  SHIP_TYPES.forEach((ship) => {
		const shipStatus = document.querySelector(
		  `div[data-ship-name="${ship.name}"].ship-status`
		);

		const count = bookings.filter((b) => b.boat === ship.name).length;

		shipStatus.dataset.hasBookings = count > 0;
		shipStatus.dataset.count = count;
		shipStatus.textContent = count;
		
		const shipHeader = shipStatus.closest(".ship-header");
		if (ship.name in myblocks) {
			if (shipHeader) {
				shipHeader.classList.add("block");
			}
		} else {
			if (shipHeader) {
				shipHeader.classList.remove("block");
			}
		}

		const shipColumn = Array.from(
		  document.querySelectorAll(`td[data-ship-name="${ship.name}"]`)
		);
		
		let colors = ['#FF0000', '#8d1a1a', '#490808', '#893f3f', '#fd6d6d', '#8d3f3f', '#FF0000', '#8d1a1a', '#490808', '#893f3f', '#fd6d6d', '#8d3f3f'];
		let ids = [];
		let i = 0;
		let y = 0;
		shipColumn.forEach((cell) => {
		  const hour = parseInt(cell.dataset.hour);
		  const minutes = parseInt(cell.dataset.minutes);
		  const key = `${ship.name}-${hour}:${minutes.toString().padStart(2, "0")}`;
		  const booking = bookedSlots.get(key);

		  const slotEl = document.createElement("div");
		  slotEl.className =
			"booking-slot flex flex-col text-sm my-1 cursor-pointer";

		  if (booking) {
			// Booked slot
			let color = '';
			if(!ids[booking.id]){
				ids[booking.id] = colors[i];
				color = colors[i];
				i++;
				y = 0;
			}else{
				color = ids[booking.id];
				y++;
			}
			
			// ${upgrade ? `<div>${upgrade}</div>` : ''}
			let upgrade = '';
			/*
			if (booking.boat != booking.upgrade) {
				const firstLetterBoat = booking.boat.charAt(0);
				const firstLetterUpgrade = booking.upgrade.charAt(0);
				upgrade = firstLetterBoat + ' → ' + firstLetterUpgrade;
			}
			*/
			if (booking.f) {
				upgrade = booking.f.charAt(0) + booking.f.charAt(1) + ' → ' + booking.boat.charAt(0) + booking.boat.charAt(1);
			}
			
			let timeTd = '';
			if (y == 1 && upgrade) {
				timeTd = 'Upgrade';
			}else{
				timeTd = `${
					booking.departure_time
				  } - ${((hours, minutes) => {
					const end = hours * 60 + minutes + parseInt(booking.duration) * 60;
					const endHour = Math.floor(end / 60);
					const endMins = end % 60;
					return `${endHour.toString().padStart(2, "0")}:${endMins
					  .toString()
					  .padStart(2, "0")}`;
				  })(parseInt(booking.departure_time.split(":")), parseInt(booking.departure_time.split(":")[1]))}`;
			}
			
			let occupadoTd = '';
			if (y == 1 && upgrade) {
				occupadoTd = upgrade;
			}else{
				occupadoTd = `${
					  booking.comments
						? `<i class="ph ph-chat-teardrop-text text-lg"></i>`
						: ""
					}
					OCCUPADO`;
			}
			
			slotEl.dataset.bookingId = booking.id;
			slotEl.innerHTML = `
			  <div style="background-color: ${color}" class="font-bold w-full bg-[#FF0000] text-white">${timeTd}</div>
			  <div style="background-color: ${color}" class="w-full bg-[#FF0000] min-h-[20px] text-white font-bold py-[1px]">
				${occupadoTd}
			  </div>
			`;

			slotEl.addEventListener("click", () => {
			  window.location.href = `/admin/booking/${booking.id}`;
			});
		  } else {
			// Available slot
			slotEl.innerHTML = `
			  <div class="font-bold w-full bg-[#61D700] text-white">${hour
				.toString()
				.padStart(2, "0")}:${minutes.toString().padStart(2, "0")} - ${
			  minutes === 0
				? `${hour.toString().padStart(2, "0")}:30`
				: `${(hour + 1).toString().padStart(2, "0")}:00`
			}</div>
			  <div class="w-full bg-[#3198FF] min-h-[20px] text-white font-bold py-[1px]">RESERVAR</div>
			`;

			slotEl.addEventListener("click", () => {
			  const departureTime = `${hour
				.toString()
				.padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
			  const formattedDate = Utils.formatDate(this.selectedDate);
			  const queryParams = new URLSearchParams({
				travel_date: formattedDate,
				boat: ship.name,
				departure_time: departureTime,
			  });
			  window.location.href = `/admin/booking/create?${queryParams.toString()}`;
			});
		  }

		  cell.appendChild(slotEl);
		});
	  });
	}

  adjustHeight(bottomNavHeight) {
    const tableContainer = document.querySelector(".overflow-x-auto");
    const availableHeight = window.innerHeight - bottomNavHeight;
    tableContainer.style.maxHeight = `${availableHeight}px`;
  }
}
